import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MenuItemType } from "./useMenuItems";

function MenuItem({
  menuItem,
  sidebarOpen,
  setSidebarOpen,
}: {
  menuItem: MenuItemType;
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (url: string) => location.pathname === url;

  const isSubActive =
    menuItem.subMenu && menuItem.subMenu.some((sub) => isActive(sub.url));

  const handleToggle = () => {
    if (menuItem.subMenu) {
      setIsOpen((prev) => !prev);
    }
  };

  const toggleSideBar = () => {
    setIsOpen((prev) => !prev);
    setSidebarOpen(false);
  };

  useEffect(() => {
  if (sidebarOpen) {
    setIsOpen(false);
  }
}, [sidebarOpen]);


  return (
    <div className="flex flex-col border-b border-[#EEEFF2]">
      {!menuItem.subMenu ? (
        <NavLink
          to={menuItem.url || "#"}
          className={`flex items-center px-5 py-3.5 cursor-pointer group transition-all duration-200 ease-in-out ${
            isActive(menuItem.url || "") ? "text-primary-500 font-bold" : ""
          } hover:text-primary-400`}
        >
          <div className="flex items-center gap-4">
            <span>{menuItem.icon}</span>
            {!sidebarOpen && (
              <span className="font-nunito transition-all duration-700 ease-in-out opacity-100 text-base-500 font-lato-body">
                {menuItem.name}
              </span>
            )}
          </div>
        </NavLink>
      ) : (
        <div
          className={`flex items-center justify-between px-5 py-3.5 cursor-pointer group transition-all duration-200 ease-in-out ${
            isActive(menuItem.url || "") || isSubActive
              ? "text-primary-500 font-bold"
              : ""
          } hover:text-primary-400`}
        >
          <div className="flex items-center gap-4">
            <button
              onClick={toggleSideBar}
              className="transition-all duration-200 ease-in-out"
            >
              {menuItem.icon}
            </button>
            {!sidebarOpen && (
              <span className="transition-all duration-300 ease-in-out opacity-100">
                {menuItem.name}
              </span>
            )}
          </div>

          {!sidebarOpen && (
            <button
              className={`transform transition-transform duration-300 ease-in-out text-gray-400 font-light text-sm ${
                isOpen ? "rotate-180" : "rotate-90"
              }`}
              onClick={handleToggle}
            >
              &#x21f2;
            </button>
          )}
        </div>
      )}

      {menuItem.subMenu && (
        <div
          className={`flex flex-col overflow-hidden transition-all duration-300 ease-in-out ${
            isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          {menuItem.subMenu.map((sub, index) => (
            <NavLink
              key={index}
              to={sub.url}
              className={`flex items-center pl-8 py-2 text-sm transition-all duration-200 ease-in-out hover:text-primary-400 text-base-500 font-nunitoy ${
                isActive(sub.url) ? "text-primary-500 font-medium" : ""
              }`}
            >
              <span className="mr-2">{isActive(sub.url) ? String.fromCharCode(0x279C) : ""}</span>

              {sub.name}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

export default MenuItem;